<top-navig [display]="true" [displayLogo]="false" title="Profile"></top-navig>
<div class="profil" [@fade]="true">
    <div class="container head" [class.p-112]="ourApp">
        <div class="row block" id="profile">
            <div class="col-md-12">
                <h4 class="heading">Mes informations:</h4>
                <button class="btn" *ngIf="!updateInfo" (click)="updateInfo=!updateInfo">
                    <i class="flaticon-edit-document"></i>
                    Modifier
                </button>
                <hr class="half_space">
                <table class="info">
                    <tr>
                        <td>Email :</td>
                        <td>
                            <span *ngIf="!updateInfo">{{customer.email}}</span>
                            <span *ngIf="updateInfo">
                                <input type="text" [(ngModel)]="customer.email" value="">
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>Nom :</td>
                        <td>
                            <span *ngIf="!updateInfo">{{customer.lastname}}</span>
                            <span *ngIf="updateInfo">
                                <input type="email" [(ngModel)]="customer.lastname" value="">
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>Prénom :</td>
                        <td>
                            <span *ngIf="!updateInfo">{{customer.firstname}}</span>
                            <span *ngIf="updateInfo">
                                <input type="text" [(ngModel)]="customer.firstname" value="">
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>Téléphone :</td>
                        <td>
                            <span *ngIf="!updateInfo">{{customer.phone}}</span>
                            <span *ngIf="updateInfo">
                                <input type="tel" [(ngModel)]="customer.phone" value="">
                            </span>
                        </td>
                    </tr>
                    <tr *ngIf="updateInfo">
                        <td>Entrer votre mot de passe pour valider la modification :</td>
                        <td>
                            <span>
                                <input type="password" [(ngModel)]="customer.oldPassword" value="">
                            </span>
                        </td>
                    </tr>
                    <tr *ngIf="updateInfo">
                        <td></td>
                        <td>
                            <div class="valider">
                                <button class="btn" (click)="updateInfo=!updateInfo">Annuler</button>
                                <button class="btn" (click)="updateUser()">Valider</button>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="row block" id="my-address">
            <div class="col-md-12">
                <h4 class="heading">Mes adresses:</h4>
                <button class="btn" (click)="addAddress()">
                    <i class="flaticon-edit-document"></i>
                    Ajouter
                </button>
                <hr class="half_space">
                <div *ngIf="address?.length==0" class="text-center">
                    <p>Aucune adresse pour le moment</p>
                </div>
                <div *ngFor="let address of address;let i=index;" class="item">
                    <div class="data"  (click)="editAddress(i)" >
                        <p>{{address.streetNumber}}, {{address.streetName}}</p>
                        <p>{{address.postalCode}}, {{address.city}}</p>
                    </div>
                    <i (click)="openModal(template,i)" class="flaticon-garbage cursor-pointer pull-right"></i>
                </div>
            </div>
        </div>
        <div class="row block" id="change-password">
            <div class="col-md-12">
                <h4 class="heading">Modifier votre mot de passe:</h4>
                <hr class="half_space">
                <p>* minimum 8 caractéres</p>
                <table class="info-pass" width="100%">
                    <tr>
                        <td>
                            <span>
                                <input type="password" placeholder="Mot de passe actuel *" [(ngModel)]="oldPassword"
                                    value="">
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span>
                                <input type="password" placeholder="Nouveau mot de passe *" [(ngModel)]="customer.password"
                                    value="">
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span>
                                <input type="password" placeholder="Confirmer le nouveau mot de passe *" [(ngModel)]="customer.confirmePassword"
                                    value="">
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>
                            <div class="valider">
                                <button class="btn" (click)="updatePassword()">Valider</button>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</div>
<ng-template #template>
    <div class="modal-body text-center">
        <p>Voulez-vous supprimer cette adresse?</p>
        <button type="button" class="btn btn-default" (click)="confirm()">Oui</button>
        <button type="button" class="btn btn-send" (click)="decline()">Non</button>
    </div>
</ng-template>